/* RESPONSIBLE TEAM: team-proactive-support */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

export class EmailTemplatesIndexRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(EmailTemplatesIndexRoute);
